module.exports = __webpack_public_path__ + "static/media/kyle-oquinn.e58879b0.jpg";